import type { AppRoute } from "@/lib/routing";
import { SuppliesPage } from "./pages/SuppliesPage";

export const routes: AppRoute[] = [
  {
    path: "/supplies",
    element: <SuppliesPage />,
    handle: {
      title: "Supplies",
      keywords: ["vials", "bottles", "pipettes", "blotters", "strips", "sprayers", "pumps", "glassware", "ethanol"],
    },
  },
  {
    path: "/supplies/list",
    lazy: async () => ({ Component: (await import("./pages/ShoppingListPage")).ShoppingListPage }),
    handle: { title: "Shopping list", keywords: ["buy", "order", "supplies", "cart"] },
  },
];
